<template>
  <div class="element-small" :class="{isTrc10:element.isTrc10}">
    <div class="header">
      <div>{{element.id}}</div>
      <!-- <a
        :href="(element.isTrc10 ?'https://tronscan.org/#/token/' :'https://tronscan.org/#/token20/')+ element.tokenIdOrAddress"
      >-->
      <a>
        <small>{{element.name}}</small>
      </a>
    </div>
        <div class="logo" :style="{backgroundImage:'url('+element.imgsrc+')'}"></div>

    <div class="balance">
      <small>{{ratio / Math.pow(10, element.decimal)}}</small>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    element: {
      type: Object,

      default: function() {
        return { isTrc10: true, id: 0, name: "", imgsrc: "" };
      }
    },
    ratio: Number
  },
  mounted() {}
};
</script>

<style scoped>
/* .element-small:hover {
  transform: scale(1.05);
  box-shadow: rgba(31, 42, 75, 0.3) 0px 20px 40px;
} */
.element-small {
  text-align: center;
  border-radius: 5px;
  cursor: pointer;
  padding: 2px;
  cursor: pointer;
  position: relative;
  box-shadow: rgba(31, 42, 75, 0.2) 0px 20px 40px;
  background: linear-gradient(
    to top,
    #155799,
    #159957
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */

  border-radius: 8px;
  overflow: hidden;
  transition: all 400ms cubic-bezier(0.23, 1, 0.32, 1) 0s;
}
.isTrc10 {
  background: linear-gradient(to top, #009688, #8bc34a);
}

.element-small .logo {
  width: 20px;
  height: 20px;
  margin: 0 auto;
  border-radius: 50%;
  background-size: cover;
  background-position: center;
  box-shadow: #8888884a 0 5px 10px;
}

.element-small .header a {
  color: white;
  font-size: x-small;
}
.element-small .header div {
  color: white;
  font-size: x-small;

  margin: 0px 0px -5px 0px;
  right: 0;
}
.element-small .balance {
      font-size: 0.6em;
  text-align: center;
  /* margin: 10px 5px 5px 5px; */
  color: white;
  font-weight: bold;
}
</style>
